import cookie from "react-cookie";
import DropDown from "../search/controls/dropdown/";
import { listingSortOptions } from "../shared/util";
import ListView from "./list-view";
import { loadCookie, parsePage } from "../shared/util";
import PageSize from "../search/page-size/page-size";
import Pagination from "../search/pagination/";
import PropTypes from "prop-types";
import React from "react";
import request from "superagent";
import ViewHeader from "./view-header";
import { SEARCH_TYPES } from "../../constants/constants";

import "./quicksearch.scss";

class QuickSearch extends React.Component {
  constructor(props, context) {
    super(props);
    this.router = context.router;
    this.state = {
      data: { results: [] },
      resultCount: 0,
      startCount: 0,
      endCount: 0,
      sortMap: {
        relevance: "asc",
        price: "desc",
        beds: "desc",
        baths: "desc",
        interior: "desc",
      },
      resultType: this.props.params.searchtype || "all",
      filter: this.constructFilter(props),
    };
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructFilter = (props) => {
    let filter = {
      activePage: parsePage(props),
      idxExclusions: props.idxExclusions,
      region: props.regionUrlParts,
      resultsPerPage: loadCookie("aw_results_per_page", [12, 24, 48], 24),
      searchKey: props.params.search,
      sortField: loadCookie("aw_sort_field", null, "relevance"),
      source: !props.supportsMls ? "sir" : null,
    };
    if (props.params.searchType !== "search") {
      filter.type = props.params.searchtype || "all";
    }
    return filter;
  };

  getStartCountEndCount = (resultCount, currentPage, resultsPerPage) => {
    let startCount = resultCount > 0 ? 1 : 0;
    let endCount;
    startCount += resultsPerPage * (currentPage - 1);
    endCount = startCount + (resultsPerPage - 1);
    if (endCount > resultCount) {
      endCount = resultCount;
    }
    this.setState({
      startCount: startCount,
      endCount: endCount,
    });
  };

  changeFilter = (name, value) => {
    let filter = this.state.filter;
    let sortMap = this.state.sortMap;
    if (name !== "activePage") {
      filter.activePage = 1;
    }
    if (name === "sortField" && filter[name] === value) {
      filter[name] = value;
      let sortValue = sortMap[value] === "desc" ? "asc" : "desc";
      sortMap[value] = sortValue;
      filter.sortDirection = sortValue;
      this.setState({ filter: filter, sortMap: sortMap }, function () {
        this.getResults();
      });
    }
    if (filter[name] !== value) {
      filter[name] = value;
      filter.sortDirection = sortMap[value];
      if (name === "resultsPerPage") {
        cookie.save("aw_results_per_page", value);
      } else if (name === "sortField") {
        cookie.save("aw_sort_field", value);
      }
      this.setState({ filter: filter }, () => {
        this.getResults();
      });
    }
  };

  gotoPage = (number) => {
    if (this.state.filter.page !== number) {
      let filter = this.state.filter;
      filter.activePage = number;
      this.router.push({
        pathname: this.props.location.pathname,
        query: {
          activePage: number,
        },
      });
      this.setState(
        {
          filter: filter,
        },
        this.getResults()
      );
    }
  };

  updateResultType = (type) => {
    const count = this.getResultCount(type);
    let filter = this.state.filter;
    filter.type = type;
    filter.activePage = 1;
    this.setState(
      {
        resultType: type,
        resultCount: count,
        filter: filter,
      },
      () => {
        this.getResults();
      }
    );
  };

  getResultCount(type) {
    let count;
    if (this.state.data) {
      switch (type) {
        case SEARCH_TYPES.SEARCH:
          count =
            this.state.data.saleTotalCount + this.state.data.rentalTotalCount;
          break;
        case SEARCH_TYPES.SALES:
          count = this.state.data.saleTotalCount;
          break;
        case SEARCH_TYPES.RENTALS:
          count = this.state.data.rentalTotalCount;
          break;
        default:
          break;
      }
    }
    this.setState({ resultCount: count });
    this.getStartCountEndCount(
      count,
      this.state.filter.activePage,
      this.state.filter.resultsPerPage
    );
  }

  componentDidMount() {
    this.getResults();
  }

  getResults = () => {
    request
      .post("/api/quicksearch/results")
      .set("Accept", "application/json")
      .send(this.state.filter)
      .end((error, response) => {
        if (!error) {
          this.setState(
            {
              data: response.body,
              resultType: this.props.params.searchtype,
            },
            () => {
              this.getResultCount(this.state.resultType);
            }
          );
        } else {
          console.error(error);
        }
      });
  };

  render() {
    let dropdown = null;
    if (
      this.state.resultType === SEARCH_TYPES.SALES ||
      this.state.resultType === SEARCH_TYPES.RENTALS
    ) {
      dropdown = (
        <div id="page-search-listing-filters">
          sorted by&nbsp;
          <DropDown
            name="sortField"
            value={this.state.filter.sortField}
            options={listingSortOptions}
            handleChange={this.changeFilter}
          />
        </div>
      );
    }
    return (
      <div className="quick-search-page">
        <div className="container web-container">
          <div className="page-header" id="results-title">
            <h3>
              {this.state.resultCount > 1
                ? this.state.resultCount + " Matches for "
                : "Match for "}
              <strong className="search-term">"{this.state.data.term}"</strong>
              &nbsp; In All Categories
            </h3>
            <div className="header-separator"></div>
          </div>
          <div className="row">
            <div className="col-xs-16 col-sm-12">
              <ViewHeader
                results={this.state.data}
                updateResultType={this.updateResultType}
                params={this.props.params}
              />
            </div>
            <div className="col-xs-16 col-sm-4">{dropdown}</div>
            <div className="col-xs-16">
              <PageSize
                resultState={this.state}
                sizeOptions={[16, 24, 48]}
                changeFilter={this.changeFilter}
              />
            </div>
            <div className="col-xs-16">
              <div id="exclusive-title">
                <ListView
                  results={this.state.data.results}
                  state={this.state}
                  params={this.props.params}
                  location={this.props.location}
                />
                <Pagination
                  count={this.state.resultCount}
                  pageSize={this.state.filter.resultsPerPage}
                  activePage={this.state.filter.activePage}
                  params={this.props.params}
                  location={this.props.location}
                  changeFilter={this.changeFilter}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="spacer-2">&nbsp;</div>
        <div className="spacer-2">&nbsp;</div>
      </div>
    );
  }
}

export default QuickSearch;



// WEBPACK FOOTER //
// ./src/components/quicksearch/quicksearch.js